import Form from './SearchForm'
import Movies from './Movies'

export default function Home() {
    return (
        <main>
            <Form/>
            <Movies/>
        </main>
    )
}
